<template>
  <Popup v-model:show="show" :style="{ backgroundColor: 'transparent' }" :close-on-click-overlay="false">
    <div class="dialog-content" :class="cssType" v-if="props.data">
      <img class="entry-img" :src="props.data.entryImageUrl" alt="img" @click="handelJoin">
      <div class="btn btn-primary" :class="locale" @click="handelJoin">
        {{ $t('payment.popupEvent.joinImmediate') }}
      </div>
      <div class="no-more-popup-wrapper" @click="handleNoMorePopup">
        <div class="no-more-popup">
          <div class="checkbox">
            <img v-if="checked" src="@/assets/imgs/dagou.png" alt="checkbox" class="checkbox-img">
          </div>
          {{ $t('payment.popupEvent.noMoreTip') }}
        </div>
      </div>
      <img src="@/assets/imgs/close.png" alt="close-btn" class="close-btn" @click="handleClose">
    </div>
  </Popup>
</template>

<script setup>
import { defineProps, ref, onMounted, watch } from 'vue'
import { Popup } from 'vant'
import { isMobile, prefix } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const DISMISS_STORAGE_KEY = `${prefix}popup_event_ann_no_more`
const props = defineProps({
  data: {
    type: Object,
    default: () => ({
      jumpLink: '',
      entryImageUrl: '',
    })
  }
})
const show = ref(false)
const checked = ref(false)

const getTodayDateString = () => {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

const isDismissedToday = () => {
  return localStorage.getItem(DISMISS_STORAGE_KEY) === getTodayDateString()
}

const setDismissedToday = () => {
  localStorage.setItem(DISMISS_STORAGE_KEY, getTodayDateString())
}

const shouldShowPopup = () => {
  if (!props.data?.entryImageUrl) return false
  return !isDismissedToday()
}

const tryShowPopup = () => {
  if (shouldShowPopup()) {
    show.value = true
  }
}

const handleNoMorePopup = () => {
  checked.value = !checked.value
}

const handleClose = () => {
  if (checked.value) {
    setDismissedToday()
  }
  show.value = false
}

const handelJoin = () => {
  window.open(props.data.jumpLink, '_blank')
}

onMounted(() => {
  tryShowPopup()
})

watch(() => props.data?.entryImageUrl, (url) => {
  if (url) {
    tryShowPopup()
  }
})
</script>

<style scoped lang="less" src="./pc_style.less"></style>
<style scoped lang="less" src="./mobile_style.less"></style>
